import {
  useWSModal,
  WSActions,
  WSAlert,
  WSElement
} from "@wingspanhq/fe-component-library";
import { IRequirementDefinitionResponse } from "@wingspanhq/payments/dist/interfaces";
import React from "react";
import { DefaultActionDetails } from "../components/DefaultActionDetails";

export interface ArchiveNotAllowedModalProps {
  requirementDefinition: IRequirementDefinitionResponse;
  onClose: () => void;
  engagementLength: number;
}

export const ArchiveNotAllowedModal: React.FC<ArchiveNotAllowedModalProps> = ({
  requirementDefinition,
  engagementLength,
  onClose
}) => {
  return (
    <>
      <DefaultActionDetails
        requirementDefinition={requirementDefinition}
        engagementLength={engagementLength}
      />

      <WSAlert
        my="2XL"
        theme="warning"
        icon="alert"
        size="M"
        title="Requirement cannot be archived when:"
      >
        <WSElement as="ul" ml="L">
          <li>Associated with active engagements.</li>
          <li>Actively assigned to contractors.</li>
        </WSElement>
      </WSAlert>

      <WSActions
        alignment="fill"
        buttons={[
          {
            label: "Done",
            onClick: onClose,
            kind: "Secondary"
          }
        ]}
      />
    </>
  );
};

export const useArchiveNotAllowedModal = () => {
  return useWSModal(ArchiveNotAllowedModal, {
    title: "Archive requirement",
    size: "M"
  });
};
